import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'dnd-npc-presets';

const loadPresets = () => {
  try {
    const raw = typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

/** Preset shape: { id, name, maxHp, ac, initiativeBonus, combatantType: 'npc'|'enemy'|'companion', speed } */
export function useNpcPresets() {
  const [presets, setPresets] = useState(loadPresets);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(presets));
    } catch (_) {}
  }, [presets]);

  const addPreset = useCallback((preset) => {
    const id = Math.random().toString(36).substr(2, 9);
    setPresets(prev => [...prev, { ...preset, id }]);
    return id;
  }, []);

  const removePreset = useCallback((id) => {
    setPresets(prev => prev.filter(p => p.id !== id));
  }, []);

  const updatePreset = useCallback((id, updates) => {
    setPresets(prev => prev.map(p => p.id === id ? { ...p, ...updates } : p));
  }, []);

  const setPresetsFromBackup = useCallback((list) => {
    if (Array.isArray(list)) setPresets(list);
  }, []);

  return { presets, setPresets, addPreset, removePreset, updatePreset, setPresetsFromBackup, loadPresets };
}

export { STORAGE_KEY as NPC_PRESETS_STORAGE_KEY };
export const getNpcPresetsFromStorage = loadPresets;
